export default __webpack_public_path__ + "static/media/pexels-marcus-aurelius-6787787_2.3c51e575.jpg";